import styled from '@emotion/styled'

import {Box} from '@vio/atlas/helpers/Box'
import {SkeletonLoader} from '@vio/atlas/SkeletonLoader'
import {cssTheme} from '@vio/atlas/themes'
import {linariaMq} from '@vio/atlas/utils/breakpoints'

const CARD_WIDTH = 192
const CARD_WIDTH_MOBILE = 155
const IMAGE_HEIGHT = 99
const IMAGE_HEIGHT_MOBILE = 78
const TITLE_LINE_HEIGHT = 24
const CTA_LINE_HEIGHT = 16

const CardWrapper = styled.div`
  border-radius: ${cssTheme.layout.radius.lg};
  background-color: ${cssTheme.colors.background.neutral.secondary};
  overflow: hidden;
  padding: ${cssTheme.layout.spacing.s300};
  min-width: ${CARD_WIDTH_MOBILE}px;
  max-width: ${CARD_WIDTH_MOBILE}px;
  display: flex;
  flex-direction: column;
  row-gap: ${cssTheme.layout.spacing.s300};
  ${linariaMq.desktopXs} {
    min-width: ${CARD_WIDTH}px;
    max-width: ${CARD_WIDTH}px;
  }
`

const ImageContainer = styled.div`
  height: ${IMAGE_HEIGHT_MOBILE}px;
  width: 100%;
  flex-shrink: 0;
  ${linariaMq.desktopXs} {
    height: ${IMAGE_HEIGHT}px;
  }
`

const TextLine = styled.div<{lineHeight: number}>`
  display: flex;
  align-items: center;
  height: ${({lineHeight}) => lineHeight}px;
`

export const HopperCarouselItemSkeleton = () => (
  <CardWrapper>
    <ImageContainer>
      <SkeletonLoader height="100%" />
    </ImageContainer>
    <Box
      paddingRight="s200"
      paddingLeft="s200"
      paddingBottom="s200"
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
    >
      <Box marginBottom="s200">
        <TextLine lineHeight={TITLE_LINE_HEIGHT}>
          <SkeletonLoader width={100} />
        </TextLine>
      </Box>
      <TextLine lineHeight={CTA_LINE_HEIGHT}>
        <SkeletonLoader width={64} />
      </TextLine>
    </Box>
  </CardWrapper>
)
